import React from 'react';

import { Button as AntdButton } from 'antd';

import { ConfigurationDto } from 'lib_api/lib/api/gen';

import { useModal } from 'hooks/modal/useModal';

import ModalDetails from '../Modals/ModalDetails/ModalDetails';
import ModalModification from '../Modals/ModalModification/ModalModification';

import './CellDetailsAndActions.less';

interface CellDetailsAndActionsProps {
  configuration: ConfigurationDto;
}

function CellDetailsAndActions({
  configuration,
}: CellDetailsAndActionsProps): React.ReactElement {
  const modalDetails = useModal(false);
  const modalModification = useModal(false);

  return (
    <>
      <AntdButton onClick={modalDetails.open}>Détails</AntdButton>
      <AntdButton className="menuActions" onClick={modalModification.open}>
        Modifier
      </AntdButton>
      <ModalDetails
        configuration={configuration}
        visible={modalDetails.visible}
        close={modalDetails.close}
      />
      <ModalModification
        configuration={configuration}
        visible={modalModification.visible}
        close={modalModification.close}
      />
    </>
  );
}

export default CellDetailsAndActions;
